import apiClient from './api-client'

function get() {
  return apiClient.get('dashboard')
}

const Dashboard = {
  get,
}

export default Dashboard
